
import {of as observableOf, Observable} from 'rxjs';

import {map} from 'rxjs/operators';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';


import {BaseService} from './base.service';
import {plainToClass} from 'class-transformer';
import {BroadcastChannelService} from '@services/broadcast-channel.service';

@Injectable()
export class AutocompleteService extends BaseService {

  constructor(http: HttpClient, broadcastChannelService: BroadcastChannelService) {
    super(http, broadcastChannelService);
  }

  getElasticSearchResults(query: string, entityType?: string, limit?: number, leagues?: string, subtypes?: string, draftYear?: number): Observable<any> {
    const ttl = 300;
    let params: HttpParams = new HttpParams();

    if (query) {
      params = params.set('q', query);
    }

    if (entityType) {
      params = params.set('entityType', entityType);
    }

    if (limit) {
      params = params.set('count', limit.toString());
    }

    if (leagues) {
      params = params.set('leagues', leagues);
    }

    if (subtypes) {
      params = params.set('subtypes', subtypes);
    }

    if (draftYear) {
      params = params.set('draftYear', draftYear.toString());
    }

    const endpoint = `${this.baseUrl}/esAutocomplete`;
    return this.get(endpoint, params).pipe(map(
      data => {
        return data;
      },
      error => {
        return error;
      }
    ));
  }
}
